import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import PlatformCMDBPage from '@src/pages/Platform/CMDB';

export const Route = createLazyFileRoute('/platform/cmdb')({
  component: PlatformCMDBPageWithLayout,
});

function PlatformCMDBPageWithLayout() {
  return (
    <DefaultLayout>
      <PlatformCMDBPage />
    </DefaultLayout>
  );
}
